<template>
  <div id="entire_app__contact_us">
    <Toast />
    <div
      class="entire_app__sidebar_container"
      :class="{
        '--sidebar_toggled': $store.state.SidebarToggle.sidebar_toggled,
      }"
    >
      <sidebar />
    </div>

    <div :class="{'--booking_in_progress': $store.state.SidebarToggle.adding_favourite_company}" class="ticket_booking_order">
      <div class="ticking_procedure_background"></div>
      <div class="error_occurred_container">
        <div class="alert_container col-mob-11">
          <div class="error_message favourite_company col-mob-11">
            <h2>Add a favourite company</h2>
            <select v-model="favourite_company">
              <option value="" selected>Select favourite company</option>
              <option v-for="(compy, index) in $store.state.SidebarToggle.all_favourite_companies" :key="index" :value="compy">{{ compy }}</option>
            </select>
            <p>Adding a favourite company helps us to give you best tickets.</p>
            <div class="btns">
              <button class="cancel" @click="$store.commit('SidebarToggle/change_adding_fav_status')">Cancel action</button>
              <button :disabled="favourite_company == ''" class="add" @click="$store.commit('SidebarToggle/addFavCompany', favourite_company)">Add favourite</button>
            </div>
          </div>
        </div>
      </div>
    </div> 

     <div v-if="$store.state.SidebarToggle.loadingPageData" :class="{'--booking_in_progress': $store.state.SidebarToggle.loadingPageData}" class="ticket_booking_order">
      <div class="ticking_procedure_background loading_data_background"></div>
      <div class="error_occurred_container">
        <div class="alert_container loading_container col-mob-11">
          <img class="logo col-mob-5" src="../assets/logo.png" alt="">
          <img class="loader" src="../assets/loading.gif" alt="">
        </div>
      </div>
    </div> 

    <div
      class="entire_app_mobile_sidebar_container"
      v-if="$store.state.Customizations.mobile_siderbar_toggled"
    >
      <mobile-sidebar />
    </div>

    <div class="__mobile_navigation">
      <div class="logo_container">
        <div class="menu_toggle">
          <svg
            id="menu"
            @click="$store.commit('Customizations/togglemobilesidebar')"
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 28 28"
          >
            <path
              id="Path_1"
              data-name="Path 1"
              d="M0,0H28V28H0Z"
              fill="none"
            />
            <path
              id="Path_2"
              data-name="Path 2"
              d="M18.889,21.5V24H5.444V21.5ZM25,12.75v2.5H3v-2.5ZM22.556,4V6.5H9.111V4Z"
              transform="translate(0)"
              fill="#1d2329"
            />
          </svg>
        </div>
        <div class="logo">
          <img src="../assets/logo.png" alt="logo" />
        </div>
        <div class="settings">
          <router-link to="/profile"
            ><svg
              @click="
                $store.commit('Customizations/togglemobilesidebartofalse')
              "
              id="settings"
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 28 28"
            >
              <path
                id="Path_3"
                data-name="Path 3"
                d="M0,0H28V28H0Z"
                fill="none"
              />
              <path
                id="Path_4"
                data-name="Path 4"
                d="M2,14a12.19,12.19,0,0,1,.379-3.024A3.6,3.6,0,0,0,5.685,9.171a3.642,3.642,0,0,0-.1-3.784,11.971,11.971,0,0,1,5.2-3.025,3.59,3.59,0,0,0,6.418,0,11.971,11.971,0,0,1,5.2,3.025,3.642,3.642,0,0,0-.1,3.786,3.6,3.6,0,0,0,3.308,1.805,12.239,12.239,0,0,1,0,6.046,3.6,3.6,0,0,0-3.307,1.8,3.642,3.642,0,0,0,.1,3.785,11.971,11.971,0,0,1-5.2,3.025,3.59,3.59,0,0,0-6.418,0,11.971,11.971,0,0,1-5.2-3.025,3.642,3.642,0,0,0,.1-3.786,3.6,3.6,0,0,0-3.308-1.805A12.215,12.215,0,0,1,2,14Zm5.765,3.623a6.065,6.065,0,0,1,.677,4.255A9.594,9.594,0,0,0,10,22.783a5.975,5.975,0,0,1,8,0,9.594,9.594,0,0,0,1.556-.906,6.062,6.062,0,0,1,.677-4.255,6,6,0,0,1,3.324-2.717,9.873,9.873,0,0,0,0-1.811,6,6,0,0,1-3.325-2.717,6.062,6.062,0,0,1-.677-4.255A9.572,9.572,0,0,0,18,5.217a5.973,5.973,0,0,1-8,0,9.573,9.573,0,0,0-1.556.906,6.062,6.062,0,0,1-.677,4.255,6,6,0,0,1-3.324,2.717,9.873,9.873,0,0,0,0,1.811,6,6,0,0,1,3.325,2.717Zm6.235,0A3.623,3.623,0,1,1,17.6,14,3.611,3.611,0,0,1,14,17.623Zm0-2.415A1.208,1.208,0,1,0,12.8,14,1.2,1.2,0,0,0,14,15.208Z"
                transform="translate(0 0)"
                fill="#1d2329"
              /></svg
          ></router-link>
        </div>
      </div>
    </div>
    <div
      class="entire_app__page_content"
      :class="{
        '--sidebar_toggled_expd_body':
          $store.state.SidebarToggle.sidebar_toggled,
      }"
    >
      <h5>
        <svg
          id="pulse-fill"
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
        >
          <path
            id="Path_31"
            data-name="Path 31"
            d="M0,0H24V24H0Z"
            fill="none"
          />
          <path
            id="Path_32"
            data-name="Path 32"
            d="M9,7.539l6,14L18.659,13H23V11H17.341L15,16.461l-6-14L5.341,11H1v2H6.659Z"
            fill="#1d2329"
          />
        </svg>
        Support
      </h5>
      <div class="faqs">
        <h4>Frequently Asked Questions</h4>
        <h6>General questions</h6>
        <div class="question" @click="showAnswer(0)">What is bookinga?</div>
        <div class="answer">
          Bookinga is an online travel booking application powered by Zexos
          group.
        </div>
        <div class="question" @click="showAnswer(1)">Why bookinga?</div>
        <div class="answer">
          Bookinga intends to cancel the discomfort caused by waiting lines at
          bus stops and bus stations by benefiting its customers with real time
          booking of journeys beforehand and only come to the place just in time
          to board the bus.
        </div>
        <div class="question" @click="showAnswer(2)">
          Is bookinga accepted by travel agencies?
        </div>
        <div class="answer">
          Yes. By the allowance of RURA and the partnership with bus companies
          such as RFTC and Ritco among many others, it is legally accepted.
        </div>
        <div class="question" @click="showAnswer(3)">
          Is bookinga safe and secured?
        </div>
        <div class="answer">
          Bookinga was built using serious technologies as a sure and safe
          solution for you and your travels, by an elite group - Zexos group.
        </div>
        <h6>Reservation questions</h6>
        <div class="question" @click="showAnswer(4)">
          Do I need to create an account to book bus tickets on Bookinga?
        </div>
        <div class="answer">
          Yes. Registering with us benefits you with realtime notifications
          about buses' arrival and time remaining to board your bus and more.
        </div>
        <div class="question" @click="showAnswer(5)">
          How do you do online bus reservation with Bookinga?
        </div>
        <div class="answer">
          It's simple. Head over to your dashboard and search for a ticket or
          click on the book button on available ticket and then follow the next
          steps.
        </div>
        <div class="question" @click="showAnswer(6)">Can I book 2 seats?</div>
        <div class="answer">
          Yes. You can choose a number of seats if there are still free on the
          bus you want to board.
        </div>
        <h6>Travelling questions</h6>
        <div class="question" @click="showAnswer(7)">
          How to reschedule my bus ticket?
        </div>
        <div class="answer">
          You can't reschedule a reservation. But you can cancel it and then
          book afresh on your postponed time.
        </div>
        <div class="question" @click="showAnswer(8)">
          How do I cancel a reservation?
        </div>
        <div class="answer">
          Currently it's not possible to cancel a reservation on bookinga app.
          But it will surely be in another complete version of bookinga.
        </div>
        <div class="question" @click="showAnswer(9)">
          Is it required to carry a print out of my bus ticket in order to board
          a bus?
        </div>
        <div class="answer">
          No, you don't. You just have to show your e-ticket sent on your device
        </div>
        <h1 class="text-center">
          Not satisfied or need other type of support?
        </h1>
      </div>
      <div class="contactus">
        <div class="words col-12 col-sm-12 col-md-6 col-lg-6">
          <h2 class="problem">Have any problem</h2>
          <h2 class="intheapp">in the app?</h2>
          <h5>Don't hesitate to call or mail us.</h5>
          <p>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="18"
              height="17"
              viewBox="0 0 18.013 18.013"
            >
              <path
                id="Icon_awesome-phone-alt"
                data-name="Icon awesome-phone-alt"
                d="M17.5,12.729l-3.94-1.689a.844.844,0,0,0-.985.243l-1.745,2.132A13.041,13.041,0,0,1,4.595,7.181L6.727,5.436a.842.842,0,0,0,.243-.985L5.281.511A.85.85,0,0,0,4.313.022L.654.866A.844.844,0,0,0,0,1.689,16.323,16.323,0,0,0,16.325,18.013a.844.844,0,0,0,.823-.654l.844-3.659a.855.855,0,0,0-.493-.971Z"
                transform="translate(0 0)"
                fill="#3b4a56"
              />
            </svg>
            &nbsp; 250786199053
          </p>
          <p>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="18"
              height="13"
              viewBox="0 0 19.269 13.007"
            >
              <path
                id="Icon_zocial-email"
                data-name="Icon zocial-email"
                d="M.072,15.923V5.22q0-.019.056-.353l6.3,5.389L.146,16.294a1.575,1.575,0,0,1-.074-.372Zm.836-11.8a.8.8,0,0,1,.316-.056H18.189a1.052,1.052,0,0,1,.334.056L12.206,9.531l-.836.669L9.716,11.556,8.062,10.2l-.836-.669Zm.019,12.9,6.336-6.076,2.453,1.988,2.453-1.988L18.5,17.019a.892.892,0,0,1-.316.056H1.224a.842.842,0,0,1-.3-.056ZM13,10.256l6.28-5.389a1.109,1.109,0,0,1,.056.353v10.7a1.424,1.424,0,0,1-.056.372Z"
                transform="translate(-0.072 -4.068)"
                fill="#3b4a56"
              />
            </svg>
            &nbsp; zexosgroup@gmail.com
          </p>
          <img src="@/assets/form.svg" />
        </div>
        <form class="col-12 col-sm-12 col-md-6 col-lg-6">
          <h2>Contact us!</h2>
          <h5>Chat with us!</h5>
          <div class="input-item">
            <input
              type="email"
              name="email"
              placeholder="Email"
              required="required"
              v-model="email"
              autocomplete="off"
              pattern="/^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/"
            />
          </div>
          <div class="message-item">
            <textarea
              name="question"
              v-model="question"
              placeholder="Message"
              required="required"
              minlength="16"
            ></textarea>
          </div>
          <div class="buttons">
            <input
              type="submit"
              value="submit"
              name="askquestion"
              @click.prevent="askQuestion()"
            />
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import Sidebar from "@/components/Sidebar.vue"; // @ is an alias to /src
import Axios from "axios";
const url = "https://bookinga.herokuapp.com/api/v1/question/ask";
import MobileSidebar from "../components/MobileSidebar.vue";
export default {
  components: {
    Sidebar,
    MobileSidebar,
  },
  data() {
    return {
      email: "",
      question: "",
    };
  },
  methods: {
    showAnswer(index) {
      var question = document.getElementsByClassName("question")[index];
      var content = question.nextElementSibling;
      const classes = content.className;
      content.className = classes.includes(" show")
        ? classes.replace(" show", "")
        : classes + " show";
    },
    askQuestion() {
      if (this.email != "" && this.question != "") {
        Axios.post(url, {
          email: this.email,
          question: this.question,
        })
          .then((response) => {
            if (response.data.success == true) {
              this.email = "";
              this.question = "";
              return this.$toast.add({
                severity: "success",
                summary: "message received successful!",
                detail:
                  "Our answering team will answer you soon via your email",
                life: 5000,
              });
            } else {
              return this.$toast.add({
                severity: "error",
                summary: "An error occured",
                detail: response.data.message,
                life: 5000,
              });
            }
          })
          .catch((error) => {
            return this.$toast.add({
              severity: "error",
              summary: "An error occured",
              detail: error.response.data.message,
              life: 5000,
            });
          });
      } else {
        return this.$toast.add({
          severity: "error",
          summary: "An error occured",
          detail: "A message or question should have all the 2 fields",
          life: 5000,
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
#entire_app__contact_us {
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  display: flex;
  flex-wrap: wrap;

   .--booking_in_progress {
    display: block !important;
  }

  .ticket_booking_order {
    position: absolute;
    width: 100%;
    height: 100%;
    background: transparent;
    z-index: 999;
    display: none;
    transition: all 0.5s ease;

    .ticking_procedure_background {
      position: fixed;
      width: 100%;
      height: 100%;
      background-color: $dimestDark;
      opacity: 0.55;
    }

    .loading_data_background {
      background-color: $pureWhite !important;
      opacity: 1 !important;
    }

    .error_occurred_container {
      width: 100%;
      height: 100%;
      background-color: transparent;
      display: flex;
      justify-content: center;
      align-items: center;
      
      .loading_container {
        flex-direction: column;
        .logo {
          width: 30%;
        }

        .loader {
          width: 10%;
          margin-top: 2em;
        }
      }

      .alert_container {
        position: fixed;
        background-color: $pureWhite;
        width: 40%;
        height: auto;
        min-height: 28% !important;
        z-index: 99;
        border-radius: 0.5em;
        display: flex;
        align-items: center;
        justify-content: center;
        transition: all .5s ease !important;
        padding: 0.2em;

        .error_image {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 30%;
          height: 100%;

          img {
            width: 85%;
            height: auto;
          }
        }

        .favourite_company {
          width: 85%;
          height: 100%;
          margin: auto;

          h2 {
            font-family: $poppins;
            font-size: 1.2em;
            font-weight: 600;
            color: $mainDark !important;
            margin: 0.8em 0;
            opacity: 0.6;
            text-align: center;
          }

          select {
            width: 100%;
            padding: 2.4% 3% 2.4% 3%;
            border-radius: 0.3em;
            background-color: $bookingInputs;
            outline: none;
            font-size: 0.88em;
            color: $mainDark;
            border: 0.11em solid $dimerBlue;
            margin-top: 0.8em;

            option {
              font-size: 0.88em;
              height: 2em;
            }
          }

          p {
            font-family: $poppins;
            font-size: 0.62em;
            color: $mainDark;
            opacity: 0.3;
            margin: 1em 0 0.6em 0;
          }

          .btns {
            width: 98%;
            height: auto;
            display: flex;
            justify-content: space-between;
            align-items: center;

            .add, .cancel {
              // width: 46%;
              font-family:satoshi, $poppins;
              font-size: 0.89em;
              font-weight: 500;
              color: $pureWhite;
              background: $mainBlue;
              margin: 1em 0 0.8em 0;
              border-radius: 0.25em;
              padding: 0.83em 3em;
              display: flex;
              justify-content: space-between;
              align-items: center;
              border: none;
            }

            .cancel {
              color: $mainDark !important;
              background: $notificationSide !important;
            }
          }
        }

        .error_message {
          width: 70%;
          height: 100%;

          h2 {
            font-family: $poppins;
            font-size: 1.2em;
            font-weight: 600;
            color: $mainRed;
            margin: 0.5em 0;
            opacity: 0.7;
          }

          h4 {
            font-family: $poppins;
            font-size: 0.8em;
            color: $mainDark;
            opacity: 0.5;
            padding-right: 0.8em;
          }

          p {
            font-family: $poppins;
            font-size: 0.62em;
            color: $mainDark;
            opacity: 0.3;
            margin: 1em 0;
          }

          button {
            font-family:satoshi, $poppins;
            font-size: 0.89em;
            font-weight: 500;
            color: $pureWhite;
            background: $mainBlue;
            margin: 1em 0 0.8em 0;
            border-radius: 0.25em;
            padding: 0.83em 3em;
            display: flex;
            justify-content: space-between;
            align-items: center;
            border: none;
          }
        }
      }
    }

    .ticket_booking_procedure_container {
      width: 100%;
      height: 100%;
      background-color: transparent;
      display: flex;
      justify-content: center;
      align-items: center;
      position: fixed;

      .procedure_form {
        position: fixed;
        background-color: $pureWhite;
        width: 35%;
        height: auto;
        min-height: 80%;
        z-index: 99;
        border-radius: 0.5em;
        display: flex;
        align-items: center;
        justify-content: center;
        transition: all .5s ease !important;
      }
    }
  }
  .entire_app_mobile_sidebar_container {
    display: none;
  }

  .__mobile_navigation {
    display: none;
  }

  .--sidebar_toggled {
    width: 6.5% !important;
    height: 100% !important;
  }

  .--sidebar_toggled_expd_body {
    width: 93.5% !important;
  }

  & .entire_app__sidebar_container {
    width: 17%;
    height: 100%;
    background: $mainDimBlue;
    transition: 0.2s ease;
  }

  & .entire_app__page_content {
    width: 83%;
    height: 100%;
    background: $pureWhite;
    transition: 0.2s ease;
    font-family:satoshi, $poppins !important;
    overflow-y: scroll !important;
  }

  h5 {
    color: $gradientDark;
    margin-top: 0.5%;
    margin-bottom: 0.5%;
    margin-left: 1%;
    font-size: 0.9em;
  }
  .faqs {
    padding: 0 2%;
    min-height: 94.2vh;
    /* border: 1px solid red; */

    h4 {
      font-size: 0.9em;
      margin-top: 1%;
    }
    h6 {
      font-size: 0.9em;
      color: #3b4a56;
      margin-bottom: 1%;
      margin-top: 2%;
    }
    h1 {
      font-size: 0.9em;
      color: #3b4a56;
      margin-top: 3%;
      margin-bottom: 3%;
    }

    .question {
      width: 100%;
      height: 7vh;
      background-color: #f4f6f9;
      border-radius: 5px;
      padding: 0.5% 2%;
      display: flex;
      align-items: center;
      font-size: 0.85em;
      color: #3b4a56;
      margin-top: 0.5%;
      cursor: pointer;
      border: none;
    }
    .answer {
      width: 100%;
      min-height: 8vh !important;
      display: none !important;
      background-color: #fafbfc;
      border-radius: 5px;
      padding: 0.5% 2%;
      font-size: 0.85em;
      color: #3b4a56;
      cursor: pointer;
      margin-bottom: 1%;
      box-shadow: 0 3px 6px #f4f6f9;

      &.show {
        display: flex !important;
        align-items: center;
      }
    }
  }
  .contactus {
    width: 95%;
    height: auto;
    padding: 1%;
    background-color: #f4f6f9;
    margin: auto;
    border-radius: 5px;
    margin-bottom: 2%;
    color: #3b4a56 !important;
    display: flex;
    flex-wrap: wrap;

    .words {
      width: 49.5%;
      height: 100%;

      img {
        width: 80%;
        margin-left: 13%;
      }
      .problem {
        margin-left: 13%;
        font-weight: 600;
        margin-top: 7% !important;
        color: $dimDark;
      }
      .intheapp {
        margin-left: 13%;
        font-weight: 600;
        color: $dimDark;
        margin-bottom: 3%;
      }
      h5 {
        margin-left: 13%;
        font-size: 0.9em;
        color: #3b4a56;
        font-weight: 600;
        margin-bottom: 7%;
      }
      p {
        margin-bottom: 2% !important;
        margin-left: 13%;
        font-size: 0.9em;
      }
    }
    form {
      width: 49.5%;
      height: 70vh;
      background-color: $pureWhite;
      box-shadow: 0 3px 6px #f0f0f0;
      border-radius: 5px;
      padding: 2.25%;
      h2,
      h5 {
        text-align: center;
      }
      h2 {
        margin-top: 3%;
        color: $mainBlue;
      }
      h5 {
        margin-bottom: 12%;
      }
    }
    .input-item {
      display: flex;
      justify-content: space-around;
      margin-bottom: 2%;
      height: 11%;
      margin-bottom: 4%;
    }
    .input-item input {
      width: 100%;
      height: 100% !important;
      border-radius: 7px;
      border: 1px solid rgba(0, 0, 0, 0.205);
      padding-left: 3%;
      padding-right: 2%;
      font-size: 0.85em;
    }
    .input-item input::placeholder {
      color: $mainDark;
      font-size: 0.95em !important;
    }
    .message-item {
      display: flex;
      justify-content: space-around;
      margin-bottom: 2%;
      height: 31%;
      margin-bottom: 4%;
    }
    .message-item textarea {
      resize: none;
      width: 100%;
      height: 100% !important;
      border-radius: 7px;
      border: 1px solid rgba(0, 0, 0, 0.205);
      padding: 2% 2% 2% 3%;
      font-size: 0.85em;
    }
    .message-item textarea::placeholder {
      color: $mainDark;
      font-size: 0.95em !important;
    }
    .buttons {
      width: 100% !important;
      height: 10%;

      input {
        width: 100% !important;
        height: 100%;
        border: none;
        background-color: $mainBlue;
        border-radius: 4px;
        color: $pureWhite;
      }
    }
    .phone_contacts{
      display: none;
    }
  }
}

//phone responsiveness
@media only screen and (max-width: 600px){
  #entire_app__contact_us {
		
			.__mobile_navigation {
				display: block;
				width: 100%;
				height: 9vh;
				background: $pureWhite;
				position: fixed;
				top: 0;
				z-index: 99;
				& .logo_container {
                    width: 100%;
                    height: 100%;
                    display: flex;
                    flex-wrap: wrap;
                    .menu_toggle {
                        width: 22%;
                        height: 100%;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        cursor: pointer;
                    }
                    .--full_width {
                        width: 100% !important;
                        height: 50% !important;
                    }
                    .--sidebar_toggled_hide_logo {
                        display: none !important;
                    }
                    .logo {
                        width: 56%;
                        height: 100%;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        img {
                            width: 60%;
                            margin-top: 0.2em;
                        }
                    }
                    .settings {
                        width: 22%;
                        height: 100%;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        cursor: pointer;
                    }
                }
			}
			.entire_app__sidebar_container{
				display: none;
			}
      //start of page(mobile) responsiveness
			.entire_app__page_content {
				display: block;
				width: 100%;
        margin-top: 9vh;
        h5 {
          margin-left: 1em;
          margin-top: 0.8em;
          svg {
            display: none;
          }
        }
        .faqs {
          h4, h6 {
            margin-left: 0.5em;
            margin-bottom: 0.9em;
            margin-top: 1em;
          }
          .question, .answer {
            padding: 2em 0.9em !important;
          }
        }
        .contactus {
          width: 95%;
          flex-wrap: wrap;

          .words {
            width: 100%;
          }
          form {
            width: 100%;
            margin-top: 2%;
          }
        }
				.content_container {
					margin-top: 9vh;
					width: 100%;
				}
				.notifications_container {
					display: none;
				}
			}
      //end of page(mobile) responsiveness

            .entire_app_mobile_sidebar_container {
                display: block;
                transition: all .5s ease;
                z-index: 999;
                width: 100%;
                height: 91vh;
                background: $pureWhite;
                position: fixed;
                top: 8vh;
                animation: slide_up .2s linear;
            }
            @keyframes slide_up {
               0% {
                  top: 8vh;
                }50%{
                  top: 5vh;
                }100%{
                  top: 8vh;
                }
            }
        }
}

//tablet responsiveness
@media only screen and (min-width: 600px) and (max-width: 768px){
.faqs{
  min-height: 0 !important;

  .question{
    height: 5vh !important;
  }
  h1 {
    margin-bottom: 0 !important;
  }
}
.contactus {
    width: 95% !important;
    height: 40% !important;
    // height: 60% !important;
    margin-top: 3% !important; 

    .words {
      width: 45% !important;
     
      img {
        width: 95% !important;
        margin-left: 5% !important;
      }
      .problem {
        text-align: start !important;
        margin-left: 13% !important;
      }
      h5{
        margin-top: 5% !important;
      }
    }

    form{
    height: 100% !important;
    width: 55% !important;

      .message-item {
      height: 40% !important;
      }
    }
}

}
</style>
